//Helper function related fo projects
import PropTypes from "prop-types";

export const projectShape = {
  region: PropTypes.string.isRequired,
  organisation: PropTypes.string,
  project: PropTypes.string,
  description: PropTypes.string,
  location: PropTypes.string,
  latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  grant_amount: PropTypes.string,
  fte_ongoing_jobs_to_be_created: PropTypes.number,
  fer: PropTypes.string,
  industry: PropTypes.string,
  program: PropTypes.string,
  link: PropTypes.string,
  label_alignment: PropTypes.string,
  label: PropTypes.string,
  label_organisation: PropTypes.string,
};

export const ensureLatAndLng = (x) => {
  const lat = parseFloat(x.latitude);
  return Boolean(lat >= -90 && lat <= 90) && Boolean(parseFloat(x.longitude));
};
export const centerFromProject = (project) => {
  return [parseFloat(project.longitude), parseFloat(project.latitude)];
};



// WEBPACK FOOTER //
// ./src/modules/project.js